import api from './api';

const supervisorService = {
  getOverview: async () => {
    const response = await api.get('/supervisors/overview');
    return response.data;
  },

  getPendingApprovals: async (params = {}) => {
    const response = await api.get('/supervisors/pending', { params });
    return response.data;
  },

  approveLog: async (id) => {
    const response = await api.post(`/supervisors/approve/${id}`);
    return response.data;
  },

  rejectLog: async (id, reason) => {
    const response = await api.post(`/supervisors/reject/${id}`, { reason });
    return response.data;
  },

  getTeamLogs: async (params = {}) => {
    const response = await api.get('/supervisors/logs', { params });
    return response.data;
  },

  getTeamMembers: async () => {
    const response = await api.get('/supervisors/team-members');
    return response.data;
  },

  getTeamKPIs: async (params = {}) => {
    const response = await api.get('/kpis/team', { params });
    return response.data;
  },
};

export default supervisorService;
